module.exports = __webpack_public_path__ + "img/camper.9dd818fe.svg";